<template>
  <div
    class="form-element"
    :class="{ '-login': isLoginPage }"
    :style="
      message == 'Doğrulama kodu yanlış tekrar deneyiniz.'
        ? 'margin-top:40px'
        : ''
    "
  >
    <label class="form-element__title" v-if="title">{{ title }}</label>
    <div class="container">
      <input
        :style="
          message == 'Doğrulama kodu yanlış tekrar deneyiniz.'
            ? 'width:178px'
            : ''
        "
        v-letter="isLetter"
        v-numeric="isNumeric"
        
        class="form-element__input"
        :class="classObject"
        type="text"
        :placeholder="placeholder"
        :name="title"
        autocomplete="off"
        @keyup="changed"
        @focus="makeWriteable"
        @blur="makeReadable"
        v-model.trim="val"
        :readonly="read"
        :maxlength="maxlength"
        :minlength="minlength"
        :onkeypress="onlyString"
 
       
      />
      <div class="info" v-if="info">
        <a
          href="https://ivd.gib.gov.tr/tvd_side/main.jsp?token=d1078f5e3dc646b78d5d4e5842f21e97feb48d366bc7617458b6679dec12675154a01fccc42292bb04d926bc259dbc75e39dd8e202535fd70a7098396c74a6f7&gn=vkndogrulamalar"
          target="_blank"
          >Vergi Kimlik No Sorgulama</a
        >
      </div>
    </div>
    <div
      class="form-element__message"
      :class="{ '-error': isError }"
      v-if="message"
    >
      {{ message }}
    </div>
    <div
      class="form-element__message"
      :class="{ '-error': isError }"
      v-if="message2"
      style="color:red"
    >
      {{ message2 }}
    </div>
  </div>
</template>

<script>
import { letter, numeric } from "@/directives/";
export default {
  props: {
    value: {
      type: [String, Number],
      default: null,
    },
    placeholder: {
      type: String,
      default: "",
    },
    isLetter: {
      type: Boolean,
      default: false,
    },
    isSecondary: {
      type: Boolean,
      default: false,
    },
    isError: {
      type: Boolean,
      default: false,
    },
    isHalf: {
      type: Boolean,
      default: false,
    },
    isQuarter: {
      type: Boolean,
      default: false,
    },
    isNumeric: {
      type: Boolean,
      default: false,
    },
    isBorder: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: null,
    },
    message: {
      type: String,
      default: null,
    },
    message2: {
      type: String,
      default: null,
    },
    maxlength: {
      type: Number,
      default: null,
    },
    minlength: {
      type: Number,
      default: null,
    },
    onlyString: {
      type: String,
      default: null,
    },
    info: {
      type: Boolean,
      default: false,
    },
 
  },
  data() {
    return {
      val: this.value,
      isLoginPage: this.$route.meta.layout == "login",
      read: true,
    };
  },
  computed: {
    classObject: function() {
      let list = {
        "-secondary": this.isSecondary,
        "-error": this.isError,
        "-half": this.isHalf,
        "-quarter": this.isQuarter,
        "-border": this.isBorder,
      };

      return list;
    },
  },
  watch: {
    value: function(val) {
      this.val = val;
    },
  },
  directives: { letter, numeric },
  methods: {
    changed: function(e) {
      this.$emit("input", e.target.value);

      return e.target.value;
    },
    makeWriteable: function() {
      this.read = false;
    },
    makeReadable: function() {
      this.read = true;
    },
  },
};
</script>

<style>
.container {
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
}
.info {
  float: left;
  align-self: center;
  padding-left: 10px;
}
</style>
